export const OTHER_SPECIFY_LABEL = 'Précisez';

export function getOtherSpecifyFieldLabel(fieldLabel: string): string {
  const normalized = fieldLabel.trim();
  if (!normalized) {
    return OTHER_SPECIFY_LABEL;
  }
  return `${OTHER_SPECIFY_LABEL} ${normalized.charAt(0).toLowerCase()}${normalized.slice(1)}`;
}

export function isOtherSelectOption(candidate: string): boolean {
  const normalized = candidate.trim().toLowerCase();
  return normalized === 'autre' || normalized === 'other';
}

export function findOtherSelectOption(options: Array<string | { label: string }>): string | undefined {
  for (const option of options) {
    const label = typeof option === 'string' ? option : option.label;
    if (isOtherSelectOption(label)) {
      return label;
    }
  }
  return undefined;
}

export function getListedStringOptions(options: Array<string | { label: string }>): string[] {
  return options
    .map((option) => (typeof option === 'string' ? option : option.label))
    .filter((option): option is string => Boolean(option));
}

export function getSelectOtherState(value: string, listedOptions: string[]) {
  const otherOption = findOtherSelectOption(listedOptions);

  if (!value) {
    return { selectValue: '', showOtherSpecify: false, otherSpecifyValue: '' };
  }

  if (isOtherSelectOption(value)) {
    return {
      selectValue: otherOption || value,
      showOtherSpecify: Boolean(otherOption),
      otherSpecifyValue: '',
    };
  }

  if (listedOptions.includes(value)) {
    return { selectValue: value, showOtherSpecify: false, otherSpecifyValue: '' };
  }

  if (otherOption) {
    return {
      selectValue: otherOption,
      showOtherSpecify: true,
      otherSpecifyValue: value,
    };
  }

  return { selectValue: value, showOtherSpecify: false, otherSpecifyValue: '' };
}
